import type { UserContextType } from '@/client/context/user'
import { hasUserRole } from '@/client/services/user'

type UserTag = 'tutor' | 'learner'

export default function getUserTag(user: UserContextType): UserTag {
  return hasUserRole(user, 'user:tutor') ? 'tutor' : 'learner'
}
